import React from "react";
import styles from "./ClickLink.module.scss";

export interface ClickLinkProps {
  pageName: string;
  name: string;
  caption: string;
  onClick: (e: React.FormEvent<HTMLButtonElement>) => void;
}
export const ClickLink = (props: ClickLinkProps) => {
  const buttonElementName = `${props.pageName}_${props.name}_button`;
  return (
    <button
      id={buttonElementName}
      name={buttonElementName}
      data-name={buttonElementName}
      className={styles.button}
      onClick={props.onClick}
    >
      {props.caption}
    </button>
  );
};
